<template>
	<div class="mt-2" v-loading="loadingContent">

		<el-tabs type="border-card" v-model="tagConfig">
			<el-tab-pane :label="i.toString()" :name="modelo.id.toString()" v-for="(modelo,i) in tableData" :key="i">
				<span slot="label">
					<i class="fa fa-list-ol"></i> {{modelo.id}} ({{modelo.nome}})
				</span>
				<Conteudo :modelo="modelo"/>
			</el-tab-pane>

			
		</el-tabs>
	</div>
</template>

<script>
	
	import TableView from 'common/table'
	import Rest from 'common/rest'
	import Conteudo from './conteudo'

  	export default {
  		name:"exame",
  		components: {TableView,Conteudo},
  		mixins:[Rest],
  		data () {
		   	return {
		   		tableData:[],
				tagConfig:'0',
				loadingContent:false

			}
		},
		beforeDestroy(){
			this.tableData = [];
		},
		created(){
			
		},

		mounted: function() {
			this.getModelo();
		},	

		methods: {

			getModelo: function(_search,_page,_pagination){
				
				this.loadingContent = true;

				this.get('ltcat/modelo',{search:_search,page:_page,pagination:_pagination}).then((result)=>{

		            result = result[0];
					this.loadingContent = false;

		             if(result.status == 200){
		             	this.tableData = result.data.data;
		             }
	            });
			},
		}
  	}
</script>


// WEBPACK FOOTER //
// index.vue?79afd143